import useToggle from "hooks/useToggle";
import { Button, Col, Collapse, Container, Row } from "reactstrap";
import SelectableOption from "./SelectableOption";

const ColumnComponent = ({ children, index, listDisplayMode, options }) => {
  return (
    <Col
      key={index}
      xs="12"
      sm={listDisplayMode === "list" ? 12 : 6}
      className={`${index !== options.length - 1 && "mb-2"} ${
        index % 2 === 0 && listDisplayMode === "grid" && "pr-1"
      } ${index % 2 !== 0 && listDisplayMode === "grid" && "pl-1"}`}
    >
      {children}
    </Col>
  );
};

const OptionsGroup = ({
  group,
  nestedGroupBy,
  listDisplayMode,
  value,
  onSelect,
  onDeselect,
  multiselect,
  labelKey,
  valueKey,
  colorKey,
  addAction,
}) => {
  const [open, toggleOpen] = useToggle(true);

  return (
    <>
      <div
        className="font-weight-500 text-dark border-bottom border-lighter pb-1 h5 cursor-pointer d-flex justify-content-between align-items-center"
        onClick={toggleOpen}
      >
        <div>
          <i className={`mdi mdi-chevron-${open ? "down" : "right"} pr-1`} />
          {group?.group}
        </div>
        {addAction && (
          <Button
            className="btn-icon-only"
            outline
            size="sm"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              addAction();
            }}
          >
            <i className="mdi mdi-plus" />
          </Button>
        )}
      </div>
      <Collapse isOpen={open}>
        <Row className="align-items-center pb-1">
          {nestedGroupBy
            ? Object.keys(group?.options)?.map((nestedGroup, k) => {
                const groupTitle = nestedGroup;
                const groupOptions = group?.options?.[nestedGroup];

                return (
                  <Container
                    key={nestedGroup}
                    className={`px-0 ${
                      k !== Object.keys(group?.options)?.length - 1 && "pb-2"
                    }`}
                  >
                    <Col
                      key={nestedGroup}
                      xs="12"
                      className="text-muted font-weight-500 pb-1"
                    >
                      {groupTitle}
                    </Col>
                    {groupOptions.map((option, k) => (
                      <ColumnComponent
                        key={k}
                        index={k}
                        listDisplayMode={listDisplayMode}
                        options={group?.options}
                      >
                        <SelectableOption
                          value={value}
                          onSelect={onSelect}
                          onDeselect={onDeselect}
                          option={option}
                          multiselect={multiselect}
                          labelKey={labelKey}
                          valueKey={valueKey}
                          colorKey={colorKey}
                        ></SelectableOption>
                      </ColumnComponent>
                    ))}
                  </Container>
                );
              })
            : group?.options?.map((option, k) => (
                <ColumnComponent
                  key={k}
                  index={k}
                  listDisplayMode={listDisplayMode}
                  options={group?.options}
                >
                  <SelectableOption
                    value={value}
                    onSelect={onSelect}
                    onDeselect={onDeselect}
                    option={option}
                    multiselect={multiselect}
                    labelKey={labelKey}
                    valueKey={valueKey}
                  ></SelectableOption>
                </ColumnComponent>
              ))}
        </Row>
      </Collapse>
    </>
  );
};

export default OptionsGroup;
